import type { UniversityRanking } from "@lib/universityRankings";
import { getUniversityIndexLabel } from "@lib/indexLabelHelpers";

function generateUniversityUrl(universitySlug: string, disciplineSlug: string, isSpecial?: boolean): string {
    return isSpecial ? `/university/${universitySlug}` : `/university/${disciplineSlug}/${universitySlug}`;
}

export function getUniversitiesTableItemTemplate(
    rankingItem: UniversityRanking["data"][number],
    disciplineSlug: string,
    isSpecial?: boolean,
): string {
    const indexLabel = getUniversityIndexLabel(disciplineSlug);

    return `<div class="cols university-item rankings-content__item">
        <span class="col col--1 cols col--tablet mx-0 py-0 px-0 center positions">
            <span class="col col--3 py-0 px-0 position">
                ${rankingItem.worldPosition || "N/A"}
                <span class="show-tablet desc">World</span>
            </span>
            <span class="col col--3 py-0 px-0 position">
                ${rankingItem.nationalPosition || "N/A"}
                <span class="show-tablet desc">National</span>
            </span>
        </span>
        <div class="col col--5-12 cols col--tablet mx-0 py-0 info">
            <span class="col col--1 px-0 py-0 img">
                <img src="${rankingItem.thumbnail}" alt="${rankingItem.university.name}" onerror="src = '/classic-rankings-frontend/images/placeholder-institution.svg'" width="64" height="64" />
            </span>
            <div class="col col--5 col--tablet">
                ${rankingItem.university.isHidden ? `<h4>${rankingItem.university.name}</h4>` : `<h4><a href="${generateUniversityUrl(rankingItem.university.slug, disciplineSlug, isSpecial)}" target="_blank">${rankingItem.university.name}</a></h4>`}
                <span class="sh">
                    ${rankingItem.university.country}
                </span>
            </div>
        </div>
        <span class="col col--5-12 py-0 cols mx-0 rankings-info">
            <span class="col col--2 col--tablet py-0 ranking">
                <span class="show-tablet desc">Scholars</span>
                <span class="ranking no-wrap">${rankingItem.numberOfScientists || "N/A"}</span>
            </span>
            <span class="col col--2 py-0 hide-tablet ranking">
                <span class="col col--3 py-0 ranking no-wrap">${rankingItem.publications?.toLocaleString() || "N/A"}</span>
            </span>
            <span class="col col--2 col--tablet tablet-no-border py-0 ranking">
                <span class="show-tablet desc">${indexLabel}</span>
                <span class="ranking no-wrap">${rankingItem.dIndex?.toLocaleString() || "N/A"}</span>
            </span>
        </span>
    </div>`;
}
